module.exports = "<div class=\"mobile-connection\" *ngIf=\"status\">\r\n    {{status}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/connectionStatus/connection-status.component.html
// module id = ../../../../../app/shared/components/connectionStatus/connection-status.component.html
// module chunks = main